import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormTcfVendorFieldGeneralLegalAddress = ()=>{
    const { __ } = useI18n();
    const { vendor: { additionalInformation } } = useFormTcfVendor();
    return /*#__PURE__*/ _jsx(Form.Item, {
        label: __("Legal address"),
        children: /*#__PURE__*/ _jsx(Input.TextArea, {
            value: additionalInformation?.legalAddress.split(";").join("\n") || "",
            readOnly: true,
            autoSize: true
        })
    });
};
export { FormTcfVendorFieldGeneralLegalAddress };
